import { Record } from "immutable";

export const aclTemplateFromJSON = (json: Partial<IAclTemplateData>): AclTemplateRecord => {
  const recordData: IAclTemplateRecord = { ...(json as any) };

  return new AclTemplateRecord(recordData);
};

export interface IAclTemplateData {
  name: string;
  descriptor: string;
}

export interface IAclTemplateRecord {
  name: string;
  descriptor: string;
}

export const defaultAclTemplate: IAclTemplateRecord = {
  name: "",
  descriptor: "",
};

export class AclTemplateRecord extends Record(defaultAclTemplate) implements IAclTemplateRecord {}
